module.exports = "span.text-danger {\n  bottom: -8px; }\n"